import React, { useState } from "react";
import { portfolioData } from "../data/portfolioData";

const navItems = [
  { id: "about", label: "About" },
  { id: "skills", label: "Tools" },
  { id: "experience", label: "Experience" },
  { id: "featured-project", label: "Featured" },
  { id: "projects", label: "Projects" },
  { id: "contact", label: "Contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleScroll = (event, id) => {
    event.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setIsOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur-xl">
      <nav className="mx-auto max-w-6xl px-4 py-4 md:px-6">
        <div className="flex items-center justify-between">
        <a
          href="#hero"
          onClick={(event) => handleScroll(event, "hero")}
          className="text-lg font-bold tracking-tight text-slate-900"
        >
          {portfolioData.name}
          <span className="ml-1 text-indigo-700">Portfolio</span>
        </a>

        <div className="hidden items-center gap-6 text-sm font-medium text-slate-600 md:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(event) => handleScroll(event, item.id)}
              className="transition hover:text-indigo-700"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(event) => handleScroll(event, "contact")}
            className="rounded-full bg-indigo-600 px-4 py-1.5 text-white transition hover:bg-indigo-500"
          >
            Contact
          </a>
        </div>

        <button
          type="button"
          className="inline-flex items-center justify-center rounded-md border border-slate-300 p-2 text-slate-700 transition hover:bg-slate-100 md:hidden"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5"
          >
            {isOpen ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <path d="M3 6h18M3 12h18M3 18h18" />
            )}
          </svg>
        </button>
        </div>

        {isOpen && (
          <div className="mt-3 space-y-1 rounded-xl border border-slate-200 bg-white p-3 shadow-lg md:hidden">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(event) => handleScroll(event, item.id)}
                className="block rounded-md px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100 hover:text-indigo-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(event) => handleScroll(event, "contact")}
              className="mt-2 block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white transition hover:bg-indigo-500"
            >
              Contact
            </a>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
